import { defaultSlickResponsive } from '@gn-audio/angularjs-components/slick/constants/default-slick-responsive';
import { IHasSlickSliderScope } from '@gn-audio/angularjs-components/slick/models/has-slick-slider-scope';
import { fetchFamilyRelated } from '@gn-audio/core/api/product-catalogue/fetch-family-related';
import { fetchGroupRelated } from '@gn-audio/core/api/product-catalogue/fetch-group-related';
import { IRelatedProduct } from '@gn-audio/core/api/product-catalogue/models/related-product';
import { ProductType } from '@gn-audio/core/common/enums';

interface IRelatedProductsSpotScope extends ng.IScope, IHasSlickSliderScope {
  relatedProducts: IRelatedProduct[];
  entityId: string;
  entityType: keyof typeof ProductType;
}

/**
 * @deprecated Should be converted into component!
 */
export class RelatedProductsController implements ng.IController {
  public static $inject: ReadonlyArray<string> = ['$scope', '$q'];

  constructor(private $scope: IRelatedProductsSpotScope, private $q: ng.IQService) {
    this.$scope.$watch('entityId + entityType', () => {
      let promise: Promise<IRelatedProduct[]>;

      switch (this.$scope.entityType) {
        case 'Family':
          promise = fetchFamilyRelated(Number(this.$scope.entityId));
          break;
        case 'Group':
          promise = fetchGroupRelated(Number(this.$scope.entityId));
          break;
        default:
          break;
      }

      if (!promise) {
        return;
      }

      this.$q
        .when(promise)
        .then((relatedProducts: IRelatedProduct[]): void => { this.$scope.relatedProducts = relatedProducts; });
    });
  }

  public $onInit(): void {
    this.$scope.responsive = defaultSlickResponsive;
  }
}
